import { autoinject, Container } from "aurelia-dependency-injection";
import { AlertsSearchModel } from "../models/alerts-search";
import { AlertsSearchView } from "./alerts-search";
import { AlertsModel } from "../models/alerts";
import { AlertsSearchListView } from "./alerts-search-list";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import { AuthorizationModel } from "../../authentication/models/authorization-model";
import { AppSettings } from "../../app-settings";
import { AppEvents } from "../../app-events";
import { AppUser } from "../../authentication/app-user";
import { ContainerHelper } from "../../shared/helpers/container-helper";

const template = require<string>("../views/alerts-searches.html");

const dom = {
    THINKER: ".thinker",
    CONTENT: ".alert-content",
    ALERT_SIGNIN_OVERRIDE: ".alert-override-link",
    MESSAGE: ".alerts-message"
};

@backboneViewProperties({
    template: template
})

export class AlertsSearchesView extends Marionette.LayoutView<AlertsModel> {
    private searchListRegion: Marionette.Region;
    private listView: AlertsSearchListView;
    private user: AppUser;
    private appEvents: Backbone.Events;

    constructor(options?) {
        super(options);
        options = options || {};
        this.user = options.user || {};
        this.appEvents = ContainerHelper.Events;
        this.setupModelListeners();
    }

    public regions(): any {
        const regions: any = {
            searchListRegion: "#alerts-search-list-region"
        };
        return regions;
    }

    public async onShow() {
        Backbone.history.navigate("my-justis/alerts/searches", {trigger: false});
        this.updateInterface();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.ALERT_SIGNIN_OVERRIDE] = (e) => this.overrideLinkClick(e);
        return events;
    }

    private updateInterface() {
        this.$(dom.MESSAGE).empty();
        if (this.user.Sku.toLowerCase() === "free") {
            this.displayFreeUserMessage();
        } else if (this.user.Sku.toLowerCase() === "open") {
            this.displayOpenUserMessage();
        } else if (this.user.AuthenticatedByIp) {
            this.displayPersonalSignInMessage();
        } else if (this.user.isAcademicUser) {
            this.displayNoEmailMessage();
        } else if (!this.user.Email) {
            this.displayNoEmailMessage();
        } else {
            this.model.fetchSearchData().then((data) => {
                this.model.SearchAlerts.set(data);
                this.setupListRegion();
            }).catch((exception) => {
                if (!this.isDestroyed) {
                    this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to retrieve search alerts. Please try again.");
                    this.$(dom.THINKER).toggle(false);
                }
            });
        }
    }

    private overrideLinkClick(e) {
        e.preventDefault();
        e.stopPropagation();
        const returnUrl = window.location.pathname;
        const signinUrl = `override?return=${returnUrl}`;
        Backbone.history.navigate(signinUrl, { trigger: true });
    }

    private setupListRegion() {
        if (this.model.SearchAlerts.length > 0) {
            const listView = new AlertsSearchListView({collection: this.model.SearchAlerts});
            this.searchListRegion.show(listView);
        } else {
            this.displayEmptySearchAlertsListMessage();
        }
    }

    private setupModelListeners() {
        this.listenTo(this.model, "change:Loaded", this.onChangeLoaded);
        this.listenTo(this.model.SearchAlerts, "destroy", this.alertDeleted);
        this.listenTo(this.user, "refresh", this.updateInterface);
    }

    private alertDeleted() {
        if (this.model.SearchAlerts.length === 0) { // If there are no more search alerts in list, then display empty list message.
            this.displayEmptySearchAlertsListMessage();
        }
    }

    private onChangeLoaded(model, property) {
       this.$(dom.THINKER).toggle(!property);
       this.$(dom.CONTENT).toggle(property);
    }

    private displayFreeUserMessage() {
        this.hideContent();
        this.$(dom.MESSAGE).append(`<p>Sorry, but alerts are only available to subscribed users. Please contact <a id="mail-link" href="mailto:helpdesklondon@vlex.com">helpdesklondon@vlex.com</a> for available options.</p>`);
    }

    private displayOpenUserMessage() {
        this.hideContent();
        this.$(dom.MESSAGE).html(`<p>Sorry, but alerts are not available in your subscriptions. Please contact <a id="mail-link" href="mailto:helpdesklondon@vlex.com">helpdesklondon@vlex.com</a> for available options.</p>`);
    }

    private displayPersonalSignInMessage() {
        this.hideContent();
        this.$(dom.MESSAGE).html(`<p>Sorry, but alerts are only available to signed in users. Please <a class="alert-override-link" href="override" data-command="signin" style="color:#fdb813">sign in as a personal user</a> to see your alerts.</p>`);
    }

    private displayEmptySearchAlertsListMessage() {
        this.$(dom.MESSAGE).empty();
        this.$(dom.CONTENT).hide();
        this.$(dom.MESSAGE).html("You currently have no search alerts set up. To create an alert, run a search and use the 'Setup Alert' button above the search results.");
    }

    private displayNoEmailMessage() {
        this.hideContent();
        this.$(dom.MESSAGE).html(`<p>Sorry, but an email is required to set up alerts.</p>`);
    }

    private hideContent() {
        this.$(dom.THINKER).hide();
        this.$(dom.CONTENT).hide();
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/alerts-searches.ts